function removei18ntags(s: string): string {
  return s.replaceAll(/<(.*?)>/g, '');
}

export { removei18ntags };
